import PageHeader from '@/components/PageHeader';
import { useMetaTags } from '@/hooks/useMetaTags';
import { useTranslation } from '@/hooks/useTranslation';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Palette, ExternalLink, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAlbumContext } from '@/contexts/AlbumProvider';
import { useAlbumNavigation } from '@/hooks/useAlbumNavigation';

const Theme = () => {
  const { t } = useTranslation();
  const { albumId } = useAlbumContext();
  const { getAlbumPath } = useAlbumNavigation();
  const panelDesignPath = albumId ? `/panel/eventos/${albumId}?tab=design` : '/panel/eventos/listado';

  useMetaTags({
    title: t('adminThemeMetaTitle'),
    pathname: '/admin/theme',
  });

  return (
    <div className="min-h-screen bg-background">
      <PageHeader title={t('colorsAndTypography')} backTo={getAlbumPath('/admin')} />

      <div className="mx-auto max-w-3xl px-4 py-8">
        <Card>
          <CardHeader>
            <div className="flex items-center space-x-2">
              <Palette className="h-5 w-5 text-primary" />
              <CardTitle>{t('themeConfiguration')}</CardTitle>
            </div>
            <CardDescription>
              La edición visual principal ahora vive en el panel del evento para unificar portada, presets, colores semánticos y tipografías.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-5">
            <div className="rounded-2xl border border-border bg-muted/30 p-5">
              <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                  <Sparkles className="h-4 w-4" />
                </div>
                <div>
                  <div className="font-semibold text-foreground">Nuevo flujo de diseño</div>
                  <p className="mt-1 text-sm leading-6 text-muted-foreground">
                    El editor nuevo reduce la personalización a seis colores semánticos y deriva automáticamente los tokens del runtime.
                  </p>
                </div>
              </div>
            </div>

            <Link to={panelDesignPath}>
              <Button>
                <ExternalLink className="mr-2 h-4 w-4" />
                Abrir Event Details &gt; Diseño
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Theme;
